export const SET_LOADING_DATA = '@reason/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@reason/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@reason/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@reason/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@reason/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@reason/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@reason/SAVE_REQUEST';
export const SAVE_SUCCESS = '@reason/SAVE_SUCCESS';

export const DELETE_ITEM = '@reason/DELETE_ITEM';
export const EDIT_ITEM = '@reason/EDIT_ITEM';

export const SEARCH = '@reason/SEARCH';

export const SET_PAGE = '@reason/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@reason/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@reason/SET_ORDER';
export const SET_ORDERBY = '@reason/SET_ORDEBY';
